import saveAs from 'file-saver';

export type FileWriterOptions = {
  name: string;
  contentType: string;
  description: string;
  extension: string;
};
export interface IFileWriter {
  options?: FileWriterOptions;
  createFile(options: FileWriterOptions): Promise<void>;
  write(content: string): Promise<void>;
  writeRaw(content: Uint8Array): Promise<void>;
  close(): Promise<void>;
  name(): string;
}
class FileSystemWriter implements IFileWriter {
  options!: FileWriterOptions;
  fileHandler!: FileSystemFileHandle;
  writableStream!: FileSystemWritableFileStream;
  createFile(options: FileWriterOptions): Promise<void> {
    return this._createFile(options);
  }
  async _createFile(options: FileWriterOptions) {
    this.options = options;
    const opts = {
      suggestedName: options.name,
      types: [
        {
          description: options.description,
          accept: { [options.contentType]: [options.extension] },
        },
      ],
    };
    this.fileHandler = await showSaveFilePicker(opts);
    this.writableStream = await this.fileHandler.createWritable();
  }
  name() {
    return this.fileHandler?.name;
  }
  write(content: string) {
    return this.writableStream.write(content);
  }
  writeRaw(content: Uint8Array) {
    return this.writableStream.write(content as FileSystemWriteChunkType);
  }
  close() {
    return this.writableStream.close();
  }
}
class BlobWriter implements IFileWriter {
  options!: FileWriterOptions;
  contentArray: string[] = [];
  createFile(options: FileWriterOptions): Promise<void> {
    return this._createFile(options);
  }
  async _createFile(options: FileWriterOptions) {
    this.options = options;
  }
  name() {
    return this.options.name;
  }
  async write(content: string) {
    this.contentArray.push(content);
  }
  writeRaw(_content: Uint8Array) {
    // TODO: Old school tech
    return Promise.reject('Not implemented');
  }
  async close() {
    const content = this.contentArray.join('');
    const blob = new Blob([content], { type: `${this.options.contentType};charset=utf-8;` });
    saveAs(blob, this.options.name);
  }
}
export class FileWriter {
  writer!: IFileWriter;
  public static async createFile(options: FileWriterOptions) {
    const supportsSaveAs = !!window.showSaveFilePicker;
    const writer = supportsSaveAs ? new FileSystemWriter() : new BlobWriter();
    await writer.createFile(options);
    return writer;
  }
}
